import React, { useState, useEffect } from "react";
import { Navbar, Nav, Row,Col,Dropdown, Container } from "react-bootstrap";
import { NavLink, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import logo from "../assets/far-logo--2.png";

const Header = () => {
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(false);
  const [openDropdownKey, setOpenDropdownKey] = useState(null);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const navLinks = [
    { path: "/", label: "Home" },
    { path: "/journals", label: "Journals" },
    { path: "/archives", label: "Archives" },
    { path: "/guide", label: "Author Guidelines" },
    { path: "/news", label: "News" },
    {
      key: "about",
      path: "/about",
      label: "About Us",
      submenu: [
        { path: "/about/fargroups", label: "About FAR" },
        { path: "/about/management_team", label: "Academic Management Consultant" },
        { path: "/about/management_governance", label: "Management And Governance" },
        { path: "/about/contact_us", label: "Contact Us" },
      ],
    },
    {
      key: "publisher",
      path: "/publisher",
      label: "Publisher Policies",
      submenu: [
        { path: "/publisher/editorial", label: "Editorial Policies" },
        { path: "/publisher/advertising", label: "Advertising Policy" },
        { path: "/publisher/article", label: "Article Correction, Retraction And Removal Policy" },
      ],
    },
  ];

  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    setOpenDropdownKey(null); // Close menus on navigation
  };

  const isParentActive = (path) => location.pathname.startsWith(path);

  return (
      <Navbar
        bg="light"
        expand="lg"
        fixed="top"
        className="nav-top shadow-sm"
        variant="dark"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        padding: "0.5rem 1rem",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
      }}
      >
        <Row className="align-items-center w-100">
          <Col xs={12} lg={1}></Col>
          <Col xs={12} lg={2} className="d-flex align-items-center">
            <Navbar.Brand as={NavLink} to="/" style={{ padding: 0 }}>
              <img src={logo} style={{ maxHeight: "60px" }} alt="FAR Logo" />
            </Navbar.Brand>
          </Col>
          <Col xs={12} lg={9}>
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="align-items-center">
                {navLinks.map((link) => {
                  const hasSubmenu = !!link.submenu;
                  
                  if (!hasSubmenu) {
                    return (
                      <Nav.Link
                        className="px-4"
                        end
                        key={link.path}
                        as={NavLink}
                        to={link.path}
                        onClick={handleScrollToTop}
                      >
                        {link.label}
                      </Nav.Link>
                    );
                  }

                  return (
                    <Dropdown
                      className="px-4"
                      key={link.key}
                      show={openDropdownKey === link.key}
                      onToggle={(isOpen) => setOpenDropdownKey(isOpen ? link.key : null)}
                    >
                      <Dropdown.Toggle
                        as="div"
                        className="nav-link link-toggle"
                        style={{
                          cursor:"pointer",
                          color: isParentActive(link.path) ? "#f7931e" : "#fff",
                        }}
                      >
                        <span className='me-1'>{link.label}</span>
                        <FontAwesomeIcon
                          icon={openDropdownKey === link.key ? faChevronUp : faChevronDown}
                          size="sm"
                        />
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        {link.submenu.map((sub) => (
                          <Dropdown.Item
                            key={sub.path}
                            as={NavLink}
                            to={sub.path}
                            onClick={handleScrollToTop}
                            className='px-4 py-2'
                          >
                            {sub.label}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  );
                })}
              </Nav>
            </Navbar.Collapse>
          </Col>
        </Row>
    </Navbar>
  );
};

export default Header;